import React, { useEffect , useState } from 'react';

import {
  Card,
  CardHeader ,
  CardBody, 
  CardTitle, 
  CardText, 
  CardSubtitle, 
  Button,
  Container,
  Row,
  Col,
  Input,
  Label,
  Form,
  FormGroup,
  ListGroup,
  ListGroupItem
} from 'reactstrap';

import { useForm } from "react-hook-form"
import { RenderErrors , FormInput  , FormError } from '../../../components/MyForm'

import {submit_registration_action} from '../actions'

const Domain = ({  
     price_id , 
     first_name ,
     last_name , 
     company_name , 
     email,  
     verification_code , 
     domain  , 
     set_domain ,
     prev_step , 
     next_step
 }) => {


  const {
    register,
    setError,
    handleSubmit,
    getValues,
    watch,
    formState: { errors }
  } = useForm( {
    mode: 'onChange',
    defaultValues: {
     'domain':  domain
    }
 });

  const [servererror , setServerError] = useState({})
  const [ submitDisabled , setSubmitDisabled ] = useState(false)

  useEffect(() => {
     
  },[]);


  return (
  <Container className="mt-3 d-flex justify-content-center align-items-center">
    
    <Card className='w-50'>
  
      <CardBody>

    <Form onSubmit={handleSubmit(async (data) => { 

        try {
            setSubmitDisabled(true)
            console.log('domain submission handle submit')
            console.log(data)
            set_domain(data['domain'])
            
            const response = await submit_registration_action({
               'first_name': first_name,
               'last_name' :  last_name,
               'email' : email , 
               'domain' : data['domain'], 
               'company_name' : company_name , 
               'price_id' : price_id
            })
            console.log(response.data)
            next_step()
        } catch (error) {
            console.log(error)
            setSubmitDisabled(false)
            if (error.response) {
                setServerError((old)=> ({...old, ...error.response.data}))
            }
        }
    })}>

    <FormGroup>
       <FormInput
        register={register}
        name='domain'
        id='domain'
        label='Domain'
        placeholder='Enter your domain name'
        type='text'
        invalid={errors.domain}
        validation={{
            required: 'domain can not be empty!',
            pattern: {
                value: /^[A-Za-z]+$/i,
                message: "Only letters are allowed"
            },
            minLength: {
                value: 3,
                message: "Minimum length is 3 letters"
            },
            maxLength: {
                value: 15,
                message: "Maximum length is 15 letters"
            }
         }}

        OnChangeCustom ={(e)=> setServerError({})}
       />

      { 
              errors.domain && 
              <FormError message={errors.domain.message}/>
      }
    </FormGroup>


     { servererror && (<RenderErrors errors={servererror}/>)}

     <ListGroup className='mt-2'>
         <ListGroupItem className="fs-7 fst-italic border-0 p-0">
           *Only letters are allowed
        </ListGroupItem>
        <ListGroupItem className="fs-7 fst-italic border-0 p-0">
           *Min 3 letters Max 15 letters
        </ListGroupItem>
     </ListGroup>

      <div className='mt-2 border-top-1'>
         <h6 className='fw-normal'>Your tenant URL will be :</h6>
         <h6 className='ms-3'>https://<span className="fw-normal">{watch('domain')!==  '' ? <>{watch('domain')}</> : <>###</>}</span>.<span className="text-muted fs-6">itoagent.com</span></h6>
      </div>


     <div className="d-flex align-items-center justify-content-center">
        <Button 
          color='primary' 
          onClick={prev_step}
         >
          Go Back
         </Button>
        &nbsp;&nbsp;
         <Button 
           color='primary'
           type="submit" 
           disabled={submitDisabled}
         >
          Submit
         </Button>

     </div>


    </Form>

        </CardBody>
      </Card>

    </Container>
  )
}

export default Domain;
